export default __webpack_public_path__ + "3bacfb7730991f6bd354e0a4c7f636b4.otf";